// extracted by mini-css-extract-plugin
module.exports = {"productUICursor":"product-ui-cursor_productUICursor__rccuH","lg":"product-ui-cursor_lg__pB14D","productUICursorContainer":"product-ui-cursor_productUICursorContainer__v9GrI"};